import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ab3c0c3a")

_pushScopeId("data-v-ab3c0c3a")
const _hoisted_1 = { class: "layouts" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_VideoSlot = _resolveComponent("VideoSlot")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isShowMediaElement(_ctx.videos))
      ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.videos, (video, index) => {
          return (_openBlock(), _createBlock(_component_VideoSlot, {
            key: JSON.stringify(video.stream),
            isShowName: !(_ctx.videos.length > 5 && _ctx.isMobileScreen),
            isMobile: _ctx.isMobileScreen,
            tile: video,
            isOverLay: _ctx.isOverLay,
            index: index,
            style: {height: `${video.height}px`, width: `${video.width}px`, top: `${video.top}px`, left: `${video.left}px`}
          }, null, 8, ["isShowName", "isMobile", "tile", "isOverLay", "index", "style"]))
        }), 128))
      : _createCommentVNode("", true)
  ]))
})